import BlockRegistry from '../../BlockRegistry';

export function registerBuzzerActuator() {
    BlockRegistry.register('buzzerActuator_buzzer_playTone', (block, context) => {
        const pin = context.getInputValue(block, 'PIN');
        const freq = context.getInputValue(block, 'FREQ');
        
        context.addSetup(`pinMode(${pin}, OUTPUT);`);
        return `tone(${pin}, ${freq})`;
    });

    BlockRegistry.register('buzzerActuator_buzzer_off', (block, context) => {
        const pin = context.getInputValue(block, 'PIN');
        
        context.addSetup(`pinMode(${pin}, OUTPUT);`);
        return `noTone(${pin})`;
    });
}
